import React from "react";
import { Portfolio } from "../../../../../graphql/generated";
import useGridState from "../../../../../Providers/GridStateProvider/hooks/useGridState";
import { homeSections } from "../../constants";
import HomeSidebar from "../HomeSidebar";
import {
  HomeBoardContent,
  HomeBoardGrid,
  HomeBoardWrapper,
  HomeLayoutWrapper,
  HomeSidebarWrapper,
} from "./styled";

interface Props {
  portfolioData: Omit<Portfolio, "createdBy">;
}

const HomeLayout: React.FC<Props> = React.memo(({ portfolioData }) => {
  const { isLoading, currentPageIndex } = useGridState();

  const renderAppropriateHomeSection = () => {
    switch (currentPageIndex) {
      case 0:
        const Component0 = homeSections[0].component;
        return <Component0 portfolioData={portfolioData} />;
      case 1:
        const Component1 = homeSections[1].component;
        return <Component1 portfolioData={portfolioData} />;
      case 2:
        const Component2 = homeSections[2].component;
        return <Component2 portfolioData={portfolioData} />;
      case 3:
        const Component3 = homeSections[3].component;
        return <Component3 portfolioData={portfolioData} />;
      case 4:
        const Component4 = homeSections[4].component;
        return <Component4 portfolioData={portfolioData} />;
      case 5:
        const Component5 = homeSections[5].component;
        return <Component5 portfolioData={portfolioData} />;
      default:
        return null;
    }
  };

  return (
    <HomeLayoutWrapper>
      <HomeSidebarWrapper>
        <HomeSidebar portfolioData={portfolioData} />
      </HomeSidebarWrapper>

      <HomeBoardWrapper>
        <HomeBoardGrid loading={isLoading ? 1 : 0}>
          <div />
          <div />
          <div />
          <div />
        </HomeBoardGrid>
        <HomeBoardContent>{renderAppropriateHomeSection()}</HomeBoardContent>
      </HomeBoardWrapper>
    </HomeLayoutWrapper>
  );
});

export default HomeLayout;
